import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { Injectable } from '@angular/core';
import { IDeployPriorityCompoundRule } from '../interfaces/deploy-priority/deploy-priority-compound-rule';
import { EditService } from './edit.service';
import { IBaseFilter } from '../interfaces/base-filter';

@Injectable({
  providedIn: 'root',
})
export class DeployPriorityCompoundRulesService extends EditService<
  IDeployPriorityCompoundRule,
  IBaseFilter
> {
  url = '/api/DeployPriorityCompoundRule';

  entityTitle = 'Deploy Priority Compound Rule';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public update(
    id: number | string,
    item: IDeployPriorityCompoundRule,
    bypassBaseHandler: boolean = false,
  ): Promise<IDeployPriorityCompoundRule> {
    const handler = bypassBaseHandler
      ? this.handlersFactory.getForReadAll()
      : this.handlersFactory.getForUpdate(this.entityTitle);
    return this.handleRequest(this.http.put(`${this.url}/${id}`, item), handler).then(
      this.extractData,
    );
  }
}
